import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import HomeInternalScene from '@Scenes/HomeInternalScene'
import HomeScene from '@Scenes/HomeScene'
import { observer } from 'mobx-react'

const RootScene = observer(() => {
    const { userStore } = useContext(StoresContext)
    if (userStore.userInfo?.isInternal) {
        return <HomeInternalScene />
    }
    return <HomeScene />
})

export default RootScene
